var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sender-mail-address" } },
    [
      _c(
        "div",
        {
          staticClass: "add-sender-address",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("span", { staticClass: "sender-mail-address" }, [
            _vm._v(_vm._s(_vm.$t("mail.addSenderAddress"))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "material-icons sender-mail-address-icon" },
            [_vm._v("add")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.data.length > 0
        ? _c(
            "div",
            [
              _c("a-table", {
                key: "vtable-" + _vm.renderCount,
                staticClass: "custom-table",
                attrs: {
                  columns: _vm.cols(),
                  dataSource: _vm.data,
                  loading: _vm.loading,
                  locale: {
                    emptyText: _vm.$t("message.noVisitorFound"),
                  },
                  pagination: false,
                  rowKey: "_id",
                  size: "small",
                },
                on: { change: _vm.tableChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "isSenderVerified",
                      fn: function (text, record) {
                        return _c("div", {}, [
                          _c("span", [
                            !record.isSenderMail ||
                            (!!record.isSenderMail && record.isSenderVerified)
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons verified-sender",
                                  },
                                  [_vm._v("verified")]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "sender-not-verified" },
                                  [
                                    _c("span", { staticClass: "isFalse" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("mail.notVerified"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons refresh-icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.isVerifiedControl(record)
                                          },
                                        },
                                      },
                                      [_vm._v("refresh ")]
                                    ),
                                  ]
                                ),
                          ]),
                        ])
                      },
                    },
                    {
                      key: "isForward",
                      fn: function (text, record) {
                        return _c("div", {}, [
                          _c(
                            "span",
                            { class: !!record.isForward ? "" : "isFalse" },
                            [
                              record.type === "user" &&
                              record.isSenderMail === false
                                ? _c("span", [_vm._v("---")])
                                : !!record.isForward
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons verified-sender",
                                    },
                                    [_vm._v("verified")]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("mail.notForwarded"))),
                                  ]),
                            ]
                          ),
                        ])
                      },
                    },
                    {
                      key: "idDefault",
                      fn: function (text, record) {
                        return _c("div", {}, [
                          _c("input", {
                            attrs: {
                              disabled: record.isSenderMail
                                ? record.isSenderVerified === false
                                : record.isVerified === false,
                              type: "radio",
                            },
                            domProps: { checked: text },
                            on: {
                              click: function ($event) {
                                return _vm.changeDefaultMail(record)
                              },
                            },
                          }),
                        ])
                      },
                    },
                    {
                      key: "delete",
                      fn: function (text, record) {
                        return _c("div", {}, [
                          _c(
                            "span",
                            {
                              staticClass: "delete-sender-mail",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteSenderMail(record)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("chatbotv2.delete")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ])
                      },
                    },
                  ],
                  null,
                  false,
                  4138131325
                ),
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end mt-3" },
                [
                  _c("Pagination", {
                    attrs: {
                      "page-change": _vm.pageChange,
                      "page-sizes": _vm.pageSizes,
                      total: _vm.total,
                      "data-v-step": "17",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "data-box" }, [
            _c("div", { staticClass: "last-session-info" }, [
              _c(
                "div",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "20px" },
                },
                [_vm._v("block")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "last-session-data",
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v(_vm._s(_vm.$t("visitor.notUserData")))]
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { footer: null, visible: _vm.isCreateModal, centered: "" },
          on: {
            cancel: function ($event) {
              _vm.isCreateModal = false
            },
          },
        },
        [
          _c(
            "a-steps",
            {
              staticStyle: { width: "50%" },
              attrs: { current: _vm.current, size: "small" },
            },
            [_c("a-step"), _vm._v(" "), _c("a-step")],
            1
          ),
          _vm._v(" "),
          _vm.current === 0
            ? _c("div", { staticClass: "custom-modal-content" }, [
                _c("div", { staticClass: "custom-modal-header" }, [
                  _vm._v(_vm._s(_vm.$t("mail.addSenderAddress"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "custom-modal-body" }, [
                  _c("div", { staticClass: "input-label" }, [
                    _vm._v(_vm._s(_vm.$t("mail.senderMailAddressDesc"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model:value",
                        value: _vm.mailAddress,
                        expression: "mailAddress",
                        arg: "value",
                      },
                    ],
                    staticClass: "sender-mail-address-input",
                    domProps: { value: _vm.mailAddress },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.verifySenderMail.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.mailAddress = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "verify-btn",
                    class: _vm.mailAddress.length > 0 ? "active" : "passive",
                    on: {
                      click: function ($event) {
                        return _vm.verifySenderMail()
                      },
                    },
                  },
                  [_vm._v("\n                Verify\n            ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.current === 1
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "custom-modal-header" }, [
                    _vm._v(_vm._s(_vm.$t("mail.gmailForwardMail"))),
                  ]),
                  _vm._v(" "),
                  _c("gif-player", { attrs: { src: _vm.getGifSrc() } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "verify-btn active",
                      on: {
                        click: function ($event) {
                          _vm.isCreateModal = false
                        },
                      },
                    },
                    [_vm._v("Done")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }